import React from "react"
import Expandable from "profiles/components/Expandable"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import * as sharedSelectors from "shared/profiles/political-committee/political-committee-selectors"
import { cleanUpHtml } from "shared/imports/sharedHelperFunctions"

import { segueToUrl } from "global-action-creators"
import { QuorumGrey5 } from "design-constants"
import { Button, DTVCard, DTVGrid } from "quorumdesign"

const politicalCommitteeCandidateMapStateToProps = (state, props) => ({
    url: sharedSelectors.selectCandidateUrl(state, props),
    name: sharedSelectors.selectCandidateName(state, props),
    imageUrl: sharedSelectors.selectCandidateImageUrl(state, props),
    committeeString: sharedSelectors.selectCandidateCommitteeString(state, props),
})

/**
 * The CandidateGrid displays a standard single DTVCard for an official
 * Currently used for the Political Committee Profile to display the
 * candidate associated to a Political Committee.
 */
export const CandidateGrid = (props) => (
    <DTVGrid collapsible collapsedGridRows={2} gridWidth={2} headerText={props.title}>
        <DTVCard
            circleColor={QuorumGrey5}
            icon={!props.name && "gavel"}
            imgUrl={props.imageUrl}
            onClick={() => props.segueToUrl(props.url)}
            text={cleanUpHtml(props.committeeString)}
            textType="primary"
            title={props.name}
        />
    </DTVGrid>
)

export const PoliticalCommitteeCandidateGrid = connect(politicalCommitteeCandidateMapStateToProps, { segueToUrl })(
    CandidateGrid,
)
